import authStore from "./stores/auth";
import testStore from "./stores/test";
import mapaStore from "./stores/mapa";
import loginStore from "./stores/login";
import entregadoresStore from "./stores/entregadores";
import relatoriosStore from "./stores/relatorios";

const stores = {
  testStore,
  mapaStore,
  loginStore,
  authStore,
  entregadoresStore,
  relatoriosStore
};

export default stores;
